// /graph/node/:slug — one node on its own page.
//
// The deep-linkable, full-width reading of a node; /graph?node=slug is the same
// content in the pane beside the drawing. Both render through NodePanel, so the
// two cannot drift apart. Here links route rather than swap a pane, because
// there is no drawing on screen to keep.
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import PageShell from "../components/PageShell";
import NodePanel from "../components/NodePanel";
import graphApi from "../services/graphApi";

export default function GraphNodePage() {
  const { slug } = useParams();
  const [node, setNode] = useState(null);
  const [known, setKnown] = useState(null);
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    setStatus("loading");
    graphApi
      .getNode(slug)
      .then((data) => {
        setNode(data);
        setStatus("ready");
      })
      .catch(() => setStatus("error"));
    // Which slugs exist decides which [[links]] render as links; a failure here
    // only costs the dangling markers, so it does not fail the page.
    graphApi
      .getOrder()
      .then((v) =>
        setKnown(new Map(v.layers.flatMap((l) => l.nodes).map((n) => [n.slug, n.title]))),
      )
      .catch(() => {});
  }, [slug]);

  return (
    <PageShell>
      <Link
        to={`/graph?node=${slug}`}
        className="text-sm text-sky-400 transition hover:text-sky-300"
      >
        ← Knowledge graph
      </Link>

      {status === "loading" && <p className="mt-6 text-slate-500">Loading…</p>}
      {status === "error" && <p className="mt-6 text-rose-400">Node not found.</p>}

      {status === "ready" && node && (
        <div className="mt-4">
          <NodePanel node={node} known={known} />
        </div>
      )}
    </PageShell>
  );
}
